import React, { useContext } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { ModalContext } from 'App';
import useFormValidator from 'useFormValidator';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import ConsolidationDetails from './components/ConsolidationDetails';
import * as actions from '../../action';
import * as c from '../../constant';

function ConsolidationContainer({
  transactionCode,
  formData,
  setFormData,
  createRichTextEditor,
  convertToRaw,
  draftToHtml,
  createMachineryApplicationTransaction,
  getMachineryApplicationsList,
  history,
}) {
  const setModal = useContext(ModalContext);
  const RULES = {
    machinery_application_id: 'required',
    tax_effectivity_year: 'required',
    tax_effectivity_quarter: 'required',
    registered: 'required',
    memoranda: 'required',
  };

  const formValidator = useFormValidator(formData, RULES);

  const validateForm = () => {
    if (!formValidator.response.is_passed) {
      return false;
    }
    return true;
  };

  const closeModal = (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure you want to cancel adding this record? Changes won`t be saved.',
      () => {
        setModal({ isOpen: false });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();
    if (validateForm() !== true) {
      return false;
    }
    const args = _.pick(
      {
        ...formData,
        rptax_transaction_code_id: transactionCode,
        memoranda: draftToHtml(
          convertToRaw(formData.memoranda.getCurrentContent())
        ),
      },
      _.keys(c.CONSOLIDATION_MACHINERY_FORM_DATA)
    );
    createMachineryApplicationTransaction(args, (data) => {
      setModal({ isOpen: false });
      getMachineryApplicationsList();
      history.push(`/rpt/machinery/applications/${_.get(data, 'data.id')}`);
    });
    return false;
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="m-1 p-1">
          <ConsolidationDetails
            formData={formData}
            setFormData={setFormData}
            validateForm={formValidator}
            transactionCode={transactionCode}
            createRichTextEditor={createRichTextEditor}
          />
          <hr className="below-hr" style={{ marginTop: 55 }} />
          <div className="py-1">
            <div className="py-1">
              <div className="col-12 d-flex justify-content-center mt-3">
                <button
                  type="button"
                  onClick={closeModal}
                  className="btn btn-light button-cancel-2 mr-1"
                  style={{ backgroundColor: '#323943', color: '#fff' }}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-light button-proceed ml-1 cms-bg-color-primary text-light"
                  disabled={!formValidator.response.is_passed}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </Modal.Body>
  );
}

ConsolidationContainer.defaultProps = {
  transactionCode: '',
};

ConsolidationContainer.propTypes = {
  transactionCode: PropTypes.string,
  createRichTextEditor: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  createMachineryApplicationTransaction:
    PropTypes.instanceOf(Function).isRequired,
  getMachineryApplicationsList: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  convertToRaw: PropTypes.instanceOf(Function).isRequired,
  draftToHtml: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(ConsolidationContainer);
